import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function Returns() {
  return (
    <PolicyPage title="Returns, Refunds & Exchanges Policy">
      <p>This voluntary policy is in addition to rights you may have under mandatory consumer law.</p>

      <h2>30-day return window</h2>
      <p>Contact us within 30 days after delivery to request a return of an eligible item. Unless the item is faulty, it must be unused, unwashed, complete, and in resalable condition with original packaging, accessories, labels, and proof of purchase. Do not send a return until we provide instructions.</p>

      <h2>Items that normally cannot be returned</h2>
      <ul>
        <li>perishable, refrigerated, or other rapidly deteriorating goods;</li>
        <li>opened food, consumables, or hygiene-sensitive goods where the seal has been broken;</li>
        <li>personalized, custom-made, or made-to-order items;</li>
        <li>digital content once supply has begun with any consent required by law;</li>
        <li>gift cards, final-sale items clearly identified before purchase, and completed workshops or services; and</li>
        <li>items damaged through misuse, improper storage, ordinary wear, or failure to follow care instructions.</li>
      </ul>
      <p>These exclusions do not apply where an item is faulty, misdescribed, or must otherwise be accepted under applicable law.</p>

      <h2>Distance-sale cancellation rights</h2>
      <p>If local law grants a cooling-off right, including a 14-day right for many eligible European distance purchases, you may notify us within the statutory period. You must then return the goods within the required time and take reasonable care of them. Legal exceptions—such as perishables, personalized goods, and certain unsealed products—still apply.</p>

      <h2>Faulty, damaged, or incorrect items</h2>
      <p>Contact us promptly with your order number, a description, and clear photographs. Depending on the circumstances and your legal rights, we may repair, replace, refund, or provide another appropriate remedy. Keep the goods and packaging until we confirm the next step.</p>

      <h2>Return shipping</h2>
      <p>For a change-of-mind return, you are responsible for safe packing and return shipping unless we state otherwise. Use a tracked service and retain the receipt; the parcel remains your responsibility until received. We cover reasonable return costs for verified faulty or incorrect goods where required by law.</p>

      <h2>Inspection and refunds</h2>
      <p>After receiving and inspecting a return, we will notify you of the decision. Approved refunds are issued to the original payment method. Processing times depend on the payment provider and bank. Original standard delivery charges are refunded only when required by law; upgraded delivery and change-of-mind return costs are normally not refundable.</p>

      <h2>Exchanges</h2>
      <p>Exchanges depend on stock. The quickest option may be to return the eligible item and place a new order. Any price difference and new shipping charge will be confirmed before the replacement is sent.</p>

      <h2>Start a request</h2>
      <p>Email <ContactEmail /> with your order number, the item, the reason for the request, and relevant photographs. We will provide the return destination and instructions; returns sent elsewhere may be delayed or refused.</p>
    </PolicyPage>
  );
}

export default Returns;
